export { default } from "../../LandingElement/SimpleSection";
